export default __webpack_public_path__ + "static/media/linie.2c6ca9fb.png";